import axios from 'axios';

import { getCookie, isProdEnv, isTestEnv } from '../../../js/utils/utils';

export const HUBSPOT_TRACKER_NAME = '_hsq';

export const HUBSPOT_TACKING_ID = '5948605';
export const isTrackerEnabled = isTestEnv() || isProdEnv();
export const isSignupTrackingEnabled = isProdEnv();

const getStepTrackingTitle = (stepIndex, isSuccess) => {
	if (isSuccess) {
		return 'Totango Self Service Success';
	}

	switch (stepIndex) {
		case 0:
			return 'Totango Self Service Signup';
		case 1:
			return 'Totango Self Service Code Confirmation';
		case 2:
			return 'Totango Self Service Password';
		case 3:
			return 'Totango Self Service User Details';
		case 4:
			return 'Totango Self Service Account Details';
		default:
			return null;
	}
};

export const isHubstopInitialized = () => window[HUBSPOT_TRACKER_NAME];
export const hubspotPageView = (stepIndex, isSuccess) => {
	const pathName = getStepTrackingTitle(stepIndex, isSuccess);
	if (isTrackerEnabled) {
		const tracker = window[HUBSPOT_TRACKER_NAME] || [];
		tracker.push(['setPath', pathName]);

		// tracking array will be send ones the script is loaded
		if (!isHubstopInitialized()) {
			window[HUBSPOT_TRACKER_NAME] = tracker;
		} else {
			tracker.push(['trackPageView']);
		}
	}
};

export const trackHubspotSignupDetailes = email => {
	if (isSignupTrackingEnabled) {
		const hubspotCookie = getCookie('hubspotutk', '');
		const SIGNUP_FORM_ID = '971deb33-77d0-4c3e-a098-072e11e54b7a';
		const requestData = {
			submittedAt: Date.now(),
			fields: [
				{
					name: 'email',
					value: email,
				},
			],
			context: {
				hutk: hubspotCookie,
			},
		};
		axios.post(
			`https://api.hsforms.com/submissions/v3/integration/submit/${HUBSPOT_TACKING_ID}/${SIGNUP_FORM_ID}`,
			requestData,
			{
				headers: {
					'Content-Type': 'application/json',
				},
			},
		);
	}
};

const Hubspot = ({ applicationId }) => {
	if (isTrackerEnabled) {
		const script = document.createElement('script');
		script.src = `//js.hs-scripts.com/${applicationId}.js`;
		script.id = 'hs-script-loader';
		document.body.appendChild(script);
	}

	return null;
};

export default Hubspot;
